/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Typography } from '@material-ui/core'

import ErrorMessageAlert from '../Utilities/ErrorMessageAlert';

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

class ErrorMessage extends Component {
    state = {
        alert_open : false
    }

    closeAlert = () => {
        this.setState({
            alert_open : false
        })
    }

    showMore = () => {
        this.setState({
            alert_open : true
        })
    }

    renderErrorAlert = () => {
        if (this.state.alert_open) {
            return (
                <ErrorMessageAlert
                    open={this.state.alert_open}
                    handleClose={this.closeAlert}
                    errorInfo={this.props.err}
                />
            )
        }
    }
    render() {
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{display: 'flex', flexDirection : 'row', alignItems : 'center', ...this.props.style}}>
                    <Typography variant = 'caption' color = 'secondary'>{this.props.error_message}</Typography>
                    <Typography style = {{cursor : 'pointer'}} variant = 'caption' color = "primary" onClick = {this.showMore}>...show more</Typography>
                </div>
                {this.renderErrorAlert()}
            </ThemeProvider>
        );
    }
}

export default ErrorMessage;